// extracted by mini-css-extract-plugin
module.exports = {"body":"ViewBody_body__1hn-G"};